import DistancingHomeLayout from "./DistancingHomeLayout";

export default DistancingHomeLayout;